define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_saving_account/validate_deposit_application_form",

        validation: {
            amount: {
                required: true,
                pattern: 'number',
                min: 1,
                max: 50000
            },
            period: {
                required: true
            },
            agree: {
                acceptance: true
            },
        },

        labels:{
            amount: "Amount",
            period: "Period",
            agree: "Consent"
        },
    });
});
